import { StatusBadge, Tag } from "../ui";

export const formatCurrency = (amount) =>
  amount != null ? new Intl.NumberFormat("en-RW", { style: "currency", currency: "RWF", maximumFractionDigits: 0 }).format(amount) : "—";

/**
 * One row per institution, study area and academic year: how many students are funded, what they
 * cost, how many are granted and the review status. Shared by HEC's selection pages and the HLI
 * admin's; each adds its own actions column. `withInstitution` adds the institution column.
 */
export const selectionColumns = (withInstitution) => [
  ...(withInstitution
    ? [{ key: "institution", label: "Institution", accessor: (r) => r.institution.name, filter: true, className: "font-semibold text-slate-900" }]
    : []),
  { key: "studyArea", label: "Study area", filter: true, className: withInstitution ? undefined : "font-semibold text-slate-900" },
  { key: "selectedNumber", label: "Students" },
  { key: "granted", label: "Granted" },
  { key: "livingAllowancePerStudent", label: "Living Allowance", render: (r) => formatCurrency(r.livingAllowancePerStudent) },
  { key: "totalLivingAllowance", label: "Total Living", render: (r) => <span className="font-semibold text-slate-900">{formatCurrency(r.totalLivingAllowance)}</span> },
  { key: "tuitionFeePerStudent", label: "Tuition Fee", render: (r) => formatCurrency(r.tuitionFeePerStudent) },
  { key: "totalTuitionFees", label: "Total Tuition", render: (r) => <span className="font-semibold text-slate-900">{formatCurrency(r.totalTuitionFees)}</span> },
  { key: "academicYear", label: "Academic Year", accessor: (r) => r.academicYear?.name, render: (r) => <Tag>{r.academicYear?.name}</Tag> },
  { key: "status", label: "Status", filter: true, accessor: (r) => r.status, render: (r) => <StatusBadge status={r.status} /> },
];
